export function getErrorMessage(error: unknown, defaultMessage: string): string {
    if (typeof error !== 'object' || error == null) return defaultMessage

    if ('errors' in error) {
        const errors = (error as { errors?: Array<{ longMessage?: string }> }).errors
        if (Array.isArray(errors)) return errors[0]?.longMessage || defaultMessage
    }

    if ('message' in error && typeof error.message === 'string' && error.message.length > 0) return error.message
    return defaultMessage
}
